export const CONTRACTOR_APPROVED_STATUS = "approved";
export const CONTRACTOR_CLIENT_VISIBLE = "client_visible";

export const normalizeContractorStatus = (value) => String(value || "").trim().toLowerCase();

export const isContractorApproved = (contractor = {}) => (
  String(contractor.role || "").toLowerCase() === "contractor"
  && contractor.account_active === true
  && normalizeContractorStatus(contractor.status) === "active"
  && normalizeContractorStatus(contractor.onboarding_status) === CONTRACTOR_APPROVED_STATUS
  && normalizeContractorStatus(contractor.visibility) === CONTRACTOR_CLIENT_VISIBLE
);

export const isContractorReviewPending = (contractor = {}) => {
  const status = normalizeContractorStatus(contractor.onboarding_status || contractor.review?.status);
  return ["submitted", "pending_review", "changes_requested"].includes(status);
};

export const contractorStatusLabel = (contractor = {}) => {
  const status = normalizeContractorStatus(contractor.onboarding_status || contractor.review?.status);
  if (status === "submitted" || status === "pending_review") return "Pending review";
  if (status === "changes_requested") return "Changes requested";
  if (status === "approved") return "Approved";
  if (status === "rejected") return "Rejected";
  if (status === "suspended") return "Suspended";
  return "Draft";
};

export const contractorStatusColor = (contractor = {}) => {
  const status = normalizeContractorStatus(contractor.onboarding_status || contractor.review?.status);
  if (status === "approved") return "success";
  if (status === "submitted" || status === "pending_review") return "warning";
  if (status === "changes_requested") return "info";
  if (status === "rejected" || status === "suspended") return "error";
  return "default";
};
